<template>
    <vue-google-autocomplete
        ref="geopicker"
        @placechanged="inputChange"
        @keyup="onKeyUp"
        :value="inputValue"
        v-bind="$attrs"
        autocomplete="off"
    />
</template>
<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
    name: "VetAddressPicker",
    components: {
        VueGoogleAutocomplete
    },
    props: {
        value: {
            type: [String],
            default: null
        },
        module: {
            type: [String],
            default: "address",
            required: true
        }
    },
    data() {
        return {
            assigned: null,
            address: {
                address: "",
                city: "",
                state: "",
                zipcode: "",
                country: ""
            }
        };
    },
    computed: {
        inputValue() {
            return this.assigned || this.value;
        }
    },
    watch: {
        value(value) {}
    },
    mounted() {
        this.addressPicked();
    },
    methods: {
        inputChange(params, place) {
            let str = "";
            let state = "";
            let county = "";

            // -- iterate place to get state long_name and county
            _.forEach(place.address_components, function (component) {
                if (
                    _.isObject(component) &&
                    component.short_name == params.administrative_area_level_1
                ) {
                    state = component.long_name;
                }

                if (_.isObject(component)) {
                    if (
                        _.findIndex(component.types, function (type) {
                            return type == "administrative_area_level_2";
                        }) > -1
                    ) {
                        county = component.long_name;
                    }
                }
            });

            // -- google place object
            if (_.isObject(params) && params.country) {
                this.address.address = (
                    _.get(params, "street_number", "") +
                    " " +
                    _.get(params, "route", "")
                ).trim();
                this.address.city = params.locality ? params.locality : "";
                this.address.state = state ? state : "";
                this.address.county = county ? county : "";
                this.address.zipcode = params.postal_code
                    ? params.postal_code
                    : "";
                this.address.country = params.country ? params.country : "";
                this.$nextTick(() => {
                    this.$refs.geopicker.update(this.address[this.module]);
                });
                this.$root.$emit("addressPicked", this.address);
                str = this.address[this.module];
            }

            // is object from inputChange
            if (params.newVal) {
                this.address[this.module] = params.newVal;
                this.$emit("input", params.newVal);
            } else if (params.newVal == "") {
                if (this.module == "address") {
                    this.address.address = "";
                    this.address.city = "";
                    this.address.state = "";
                    this.address.county = "";
                    this.address.zipcode = "";
                    this.address.country = "";
                    this.$root.$emit("addressPicked", this.address);
                } else {
                    this.address[this.module] = "";
                    this.$emit("input", "");
                }
            }

            this.assigned = str;
        },
        addressPicked() {
            this.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    this.assigned = address[this.module];
                    this.$emit("input", this.assigned);
                }
            });
        },
        onKeyUp(evt) {
            if (evt.keyCode !== 9) {
                this.inputChange(
                    { newVal: this.$refs.geopicker.autocompleteText },
                    this.module
                );
            }
        }
    }
};
</script>
